<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 1L2 6L7 11" stroke="currentColor" stroke-width="1.5"/>
      <line x1="2" y1="6" x2="12" y2="6" stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>

